import React from "react";
import FeaturePageLayout from "./FeaturePageLayout";

const cards = [
  {
    bg: "#dbeafe",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    title: "Multiagente em Tempo Real",
    desc: "Vários atendentes trabalham simultâneos com visibilidade total das filas, status e histórico de cada ticket.",
  },
  {
    bg: "#EFF6FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
    title: "Chatbot sem Programar",
    desc: "Monte fluxos de atendimento visual com condições, menus, API e transferência para humano quando necessário.",
  },
  {
    bg: "#E6F7FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    title: "Filas e SLA",
    desc: "Organize atendimentos em filas por produto, equipe ou prioridade com alertas automáticos de SLA estourado.",
  },
  {
    bg: "#fce7f3",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
    title: "Respostas Rápidas",
    desc: "Biblioteca de templates para respostas frequentes. Economize tempo e padronize a comunicação da equipe.",
  },
  {
    bg: "#fef3c7",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    title: "Transferência com Histórico",
    desc: "Ao transferir um ticket entre agentes, o novo atendente recebe todo o contexto anterior sem perda de informação.",
  },
  {
    bg: "#ffedd5",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>,
    title: "Relatórios de Suporte",
    desc: "TMA, TMR, volume por canal, agente e horário — dados que mostram onde melhorar o atendimento.",
  },
];

const steps = [
  { title: "Ticket aberto automaticamente", desc: "Toda mensagem recebida cria um ticket e é direcionada para a fila correta por regras configuráveis." },
  { title: "Chatbot resolve o que puder", desc: "Respostas automáticas para dúvidas frequentes reduzem o volume que chega aos atendentes humanos." },
  { title: "Agente assume com contexto completo", desc: "O atendente vê o histórico, as mensagens do bot e os dados do cliente antes de digitar uma linha sequer." },
  { title: "Encerra e coleta satisfação", desc: "Ao fechar o ticket, um CSAT automático é enviado ao cliente para avaliar o atendimento recebido." },
];

const visual = {
  icon: (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  label: "Suporte Omnichannel",
  sub: "Todos os canais em um único painel",
};

const FeatureSuporte = () => (
  <FeaturePageLayout
    tag="Suporte & Atendimento"
    title="Atendimento rápido"
    titleHi="e sem atritos"
    sub="Centralize WhatsApp, Messenger, Instagram e e-mail em um único painel. Filas, chatbot e SLA integrados para sua equipe atender mais com menos esforço."
    cards={cards}
    steps={steps}
    visual={visual}
  />
);

export default FeatureSuporte;
